// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function mail_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var is_verified = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_verified"), null));
  if (is_verified.TAG === /* Ok */0) {
    var email = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
    if (email.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                is_verified: is_verified._0,
                email: email._0
              }
            };
    }
    var e = email._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".email" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = is_verified._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is_verified" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var mobile = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mobile"), null));
  if (mobile.TAG === /* Ok */0) {
    var first_name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "first_name"), null));
    if (first_name.TAG === /* Ok */0) {
      var last_name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_name"), null));
      if (last_name.TAG === /* Ok */0) {
        var blacklisted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "blacklisted"), null));
        if (blacklisted.TAG === /* Ok */0) {
          var mail_info = mail_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mail_info"), null));
          if (mail_info.TAG === /* Ok */0) {
            var external_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "external_id"), null));
            if (external_id.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        mobile: mobile._0,
                        first_name: first_name._0,
                        last_name: last_name._0,
                        blacklisted: blacklisted._0,
                        mail_info: mail_info._0,
                        external_id: external_id._0
                      }
                    };
            }
            var e = external_id._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".external_id" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = mail_info._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".mail_info" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = blacklisted._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".blacklisted" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = last_name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".last_name" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = first_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".first_name" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = mobile._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".mobile" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

export {
  mail_info_decode ,
  t_decode ,
}
/* No side effect */
